import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-327f52f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "living-people-editor" }
const _hoisted_2 = { class: "group-by" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Show relationship to:", -1))
const _hoisted_4 = { class: "list-unstyled living-people-list" }

import { computed } from 'vue'
import { Person } from '@webapp/rd/ResearchDataModel'
import { useSyncSessionStore } from './SyncSessionStore'
import { RelationshipCategory, orderedRelationshipCategories, buildLivingWindowGroups } from './LivingWindowGroups'
import LivingPeopleCategory from './LivingPeopleCategory.vue'
import LivingPersonListItem from './LivingPersonListItem.vue'
import SourcePersonSelector from './SourcePersonSelector.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LivingPeopleEditor',
  props: {
    sessionId: {}
  },
  setup(__props: any) {

const props = __props;



const syncSessionStore = useSyncSessionStore()
const stateRef = computed(() => syncSessionStore.getState(props.sessionId))

const startPersonIdRef = computed({
  get: () => stateRef.value?.livingStartPersonId,
  set: (value) => {
    const state = stateRef.value
    if (state) {
      state.livingStartPersonId = value
    }
  },
})

const livingWindowGroupsRef = computed(() => {
  const graph = stateRef.value?.sourceGraph
  return graph
    ? buildLivingWindowGroups(graph, stateRef.value?.livingStartPersonId)
    : new Map<RelationshipCategory, Person[]>()
})

const categoriesRef = computed(() => orderedRelationshipCategories.filter(rc =>
  rc != RelationshipCategory.Ancestor ||
  (livingWindowGroupsRef.value.get(rc) ?? []).length > 0))

const otherPersonsRef = computed(() => livingWindowGroupsRef.value.get(RelationshipCategory.Other) ?? [])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(SourcePersonSelector, {
        modelValue: startPersonIdRef.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startPersonIdRef).value = $event)),
        "session-id": _ctx.sessionId
      }, null, 8, ["modelValue", "session-id"])
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (startPersonIdRef.value)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(categoriesRef.value, (rc) => {
            return (_openBlock(), _createElementBlock("li", { key: rc }, [
              _createVNode(LivingPeopleCategory, {
                category: rc,
                persons: livingWindowGroupsRef.value.get(rc) ?? [],
                "session-id": _ctx.sessionId
              }, null, 8, ["category", "persons", "session-id"])
            ]))
          }), 128))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(otherPersonsRef.value, (p) => {
            return (_openBlock(), _createElementBlock("li", {
              key: p.id
            }, [
              _createVNode(LivingPersonListItem, {
                person: p,
                "session-id": _ctx.sessionId
              }, null, 8, ["person", "session-id"])
            ]))
          }), 128))
    ])
  ]))
}
}

})